import useClientContext from "./useClientContext";

import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

export default () => {
    const location = useLocation();
    const sendDataToGTM = useGTMDispatch();
    const { isClient } = useClientContext();

    const [originalLocation, setOriginalLocation] = useState<string>();
    const [referer, setReferer] = useState<string>();

    useEffect(() => {
        if (isClient) {
            window.dataLayer = window.dataLayer || [];

            // Fixes "The Rogue Referral Problem" for Single-page sites
            // https://www.simoahava.com/gtm-tips/fix-rogue-referral-problem-single-page-sites/
            const url = document.location.protocol + "//" + document.location.hostname + document.location.pathname + document.location.search;
            if (typeof (originalLocation) === "undefined") {
                setOriginalLocation(url);
                setReferer(url);
            }

            // Trigger on all sites
            sendDataToGTM({
                "event": "Heyday.FirstPageview",
                "eventTimeout": 2000,
                "originalLocation": url
            });
        }
    }, []);

    useEffect(() => {
        if (isClient) {
            window.dataLayer = window.dataLayer || [];

            // Trigger for all other pages after this
            const url = document.location.protocol + "//" + document.location.hostname + document.location.pathname + document.location.search;
            setReferer(url);

            if (referer !== url) {
                sendDataToGTM({
                    "event": "Heyday.Pageview",
                    "eventTimeout": 2000,
                    "originalLocation": originalLocation ?? url
                });
            }
        }
    }, [referer, location, originalLocation]);

    return;
};